(function () {
  if (window.__collectionSubcategoriesInit) {
    return;
  }

  window.__collectionSubcategoriesInit = true;

  var abortController = null;
  var activeRequestId = 0;
  var colorSwatchBound = false;
  var NAV_SELECTOR = '.shopify-section--collection-subcats a.CollectionSubcats__Btn';
  var PRODUCT_COUNT_SELECTOR = '[data-collection-product-count]';

  function getCollectionSection() {
    return document.querySelector('[data-section-type="collection"]');
  }

  function getCollectionSubcategoriesSection() {
    return document.querySelector('.shopify-section--collection-subcats');
  }

  function getCollectionProductsContainer(collectionSection) {
    return collectionSection ? collectionSection.querySelector('.CollectionInner__Products') : null;
  }

  /**
   * Sync Filter/Sort bar product count from AJAX section HTML.
   * Prefers Shopify-provided count (data attribute / Liquid markup) over DOM card counting.
   */
  function syncCollectionProductCount(targetRoot, sourceRoot) {
    if (!targetRoot || !sourceRoot) {
      return;
    }

    var sourceCount = sourceRoot.querySelector(PRODUCT_COUNT_SELECTOR);

    if (!sourceCount) {
      return;
    }

    var countValue = sourceCount.getAttribute('data-collection-product-count');
    var countLabel = sourceCount.textContent;

    targetRoot.querySelectorAll(PRODUCT_COUNT_SELECTOR).forEach(function (targetCount) {
      if (countValue !== null) {
        targetCount.setAttribute('data-collection-product-count', countValue);
      }

      targetCount.textContent = countLabel;
    });
  }

  window.syncCollectionProductCount = syncCollectionProductCount;

  function shouldEnhanceNavigation() {
    if (window.Shopify && window.Shopify.designMode) {
      return false;
    }

    return Boolean(getCollectionSection() && getCollectionSubcategoriesSection());
  }

  function normalizePathname(url) {
    try {
      return new URL(url, window.location.origin).pathname.replace(/\/$/, '') || '/';
    } catch (error) {
      return '';
    }
  }

  function setAjaxCollectionUrl(collectionSection, url) {
    if (!collectionSection) {
      return;
    }

    var selectedPath = normalizePathname(url);
    var pagePath = normalizePathname(window.location.href);

    // Native CollectionSection filtering can own the real page collection.
    // For any other collection, keep fetches pointed at the AJAX-selected URL.
    if (selectedPath && selectedPath !== pagePath) {
      collectionSection.setAttribute('data-ajax-collection-url', selectedPath);
    } else {
      collectionSection.removeAttribute('data-ajax-collection-url');
    }
  }

  function setFilterChromeVisible(collectionSection, visible) {
    var display = visible ? '' : 'none';

    collectionSection.querySelectorAll('.CollectionToolbar').forEach(function (toolbar) {
      toolbar.style.display = display;
    });

    collectionSection.querySelectorAll('.CollectionInner__Sidebar').forEach(function (sidebar) {
      sidebar.style.display = display;
    });

    var filterDrawer = collectionSection.querySelector('#collection-filter-drawer');

    if (filterDrawer) {
      filterDrawer.style.display = display;
      if (!visible) {
        filterDrawer.setAttribute('aria-hidden', 'true');
      }
    }
  }

  function replaceNodeContents(currentNode, newNode) {
    if (!currentNode || !newNode) {
      return false;
    }

    currentNode.innerHTML = newNode.innerHTML;
    currentNode.className = newNode.className;
    return true;
  }

  function syncCollectionFilters(collectionSection, tempElement) {
    collectionSection.querySelectorAll('.CollectionToolbar').forEach(function (toolbar) {
      var newToolbar = tempElement.querySelector('.CollectionToolbar');

      if (newToolbar) {
        replaceNodeContents(toolbar, newToolbar);
        toolbar.style.display = '';
      } else {
        toolbar.style.display = 'none';
      }
    });

    var currentSidebar = collectionSection.querySelector('.CollectionInner__Sidebar');
    var newSidebar = tempElement.querySelector('.CollectionInner__Sidebar');
    var collectionInner = collectionSection.querySelector('.CollectionInner');

    if (newSidebar && currentSidebar) {
      replaceNodeContents(currentSidebar, newSidebar);
      currentSidebar.style.display = '';
    } else if (newSidebar && !currentSidebar && collectionInner) {
      collectionInner.insertAdjacentHTML('afterbegin', newSidebar.outerHTML);
    } else if (currentSidebar) {
      currentSidebar.innerHTML = '';
      currentSidebar.style.display = 'none';
    }

    var collectionFiltersDrawer = collectionSection.querySelector('#collection-filters-drawer-form');
    var newDrawerContent = tempElement.querySelector('#collection-filters-drawer-form');
    var filterDrawer = collectionSection.querySelector('#collection-filter-drawer');

    if (collectionFiltersDrawer && newDrawerContent) {
      collectionFiltersDrawer.innerHTML = newDrawerContent.innerHTML;
      if (filterDrawer) {
        filterDrawer.style.display = '';
      }
    } else if (collectionFiltersDrawer) {
      collectionFiltersDrawer.innerHTML = '';
      if (filterDrawer) {
        filterDrawer.style.display = 'none';
        filterDrawer.setAttribute('aria-hidden', 'true');
      }
    }

    var collectionFiltersSidebar = collectionSection.querySelector('#collection-filters-sidebar-form');
    var newSidebarContent = tempElement.querySelector('#collection-filters-sidebar-form');

    if (collectionFiltersSidebar && newSidebarContent) {
      collectionFiltersSidebar.innerHTML = newSidebarContent.innerHTML;
    } else if (collectionFiltersSidebar) {
      collectionFiltersSidebar.innerHTML = '';
    }

    var currentSortList = collectionSection.querySelector('#collection-sort-popover .Popover__ValueList');
    var newSortList = tempElement.querySelector('#collection-sort-popover .Popover__ValueList');

    if (currentSortList && newSortList) {
      currentSortList.innerHTML = newSortList.innerHTML;
    }

    // Clear-filter buttons inside the product empty state / toolbar must use the new collection URL
    collectionSection.querySelectorAll('[data-action="clear-filters"]').forEach(function (button) {
      var matching = tempElement.querySelector('[data-action="clear-filters"]');
      if (matching && matching.getAttribute('data-url')) {
        button.setAttribute('data-url', matching.getAttribute('data-url'));
      }
    });
  }

  function applyCollectionContent(collectionSection, tempElement) {
    var collectionProducts = getCollectionProductsContainer(collectionSection);
    var newProducts = tempElement.querySelector('.CollectionInner__Products');
    var emptyState = !newProducts ? tempElement.querySelector('.EmptyState') : null;

    if (!collectionProducts) {
      throw new Error('Collection products container missing from page');
    }

    if (newProducts) {
      setFilterChromeVisible(collectionSection, true);
      collectionProducts.innerHTML = newProducts.innerHTML;
      syncCollectionFilters(collectionSection, tempElement);
      syncCollectionProductCount(collectionSection, tempElement);
      return;
    }

    if (emptyState) {
      setFilterChromeVisible(collectionSection, false);
      collectionProducts.innerHTML = emptyState.outerHTML;

      var drawerForm = collectionSection.querySelector('#collection-filters-drawer-form');
      var sidebarForm = collectionSection.querySelector('#collection-filters-sidebar-form');
      if (drawerForm) drawerForm.innerHTML = '';
      if (sidebarForm) sidebarForm.innerHTML = '';

      // Empty subcollection: reflect zero products in any remaining count nodes
      collectionSection.querySelectorAll(PRODUCT_COUNT_SELECTOR).forEach(function (targetCount) {
        targetCount.setAttribute('data-collection-product-count', '0');
        targetCount.textContent = '0 Items';
      });

      return;
    }

    throw new Error('Collection products container missing from response');
  }

  function updateActiveSubcategory(subcategoriesSection, activeUrl) {
    if (!subcategoriesSection) {
      return;
    }

    var activePath = normalizePathname(activeUrl);

    subcategoriesSection.querySelectorAll('a.CollectionSubcats__Btn').forEach(function (link) {
      var isActive = normalizePathname(link.href) === activePath;
      link.classList.toggle('is-active', isActive);

      if (isActive) {
        link.setAttribute('aria-current', 'page');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  function revealProductItems(collectionSection) {
    collectionSection.querySelectorAll('.ProductList .ProductItem').forEach(function (item) {
      item.classList.add('visible-product');
      item.style.visibility = 'inherit';
      item.style.opacity = '1';
      item.style.transform = 'matrix(1, 0, 0, 1, 0, 0)';
    });
  }

  function bindColorSwatchDelegation(collectionSection) {
    if (colorSwatchBound || !collectionSection) {
      return;
    }

    colorSwatchBound = true;

    collectionSection.addEventListener('change', function (event) {
      var target = event.target;

      if (!target || !target.classList || !target.classList.contains('ColorSwatch__Radio')) {
        return;
      }

      var productItem = target.closest('.ProductItem');

      if (!productItem) {
        return;
      }

      var variantUrl = target.getAttribute('data-variant-url');

      if (variantUrl) {
        var imageWrapper = productItem.querySelector('.ProductItem__ImageWrapper');
        var titleLink = productItem.querySelector('.ProductItem__Title > a');

        if (imageWrapper) {
          imageWrapper.setAttribute('href', variantUrl);
        }

        if (titleLink) {
          titleLink.setAttribute('href', variantUrl);
        }
      }

      var originalImageElement = productItem.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');

      if (
        !originalImageElement ||
        !target.hasAttribute('data-image-url') ||
        target.getAttribute('data-image-id') === originalImageElement.getAttribute('data-image-id')
      ) {
        return;
      }

      var newImageElement = document.createElement('img');
      newImageElement.className = 'ProductItem__Image Image--fadeIn Image--lazyLoad';
      newImageElement.setAttribute('data-image-id', target.getAttribute('data-image-id'));
      newImageElement.setAttribute('data-src', target.getAttribute('data-image-url'));
      newImageElement.setAttribute('data-widths', target.getAttribute('data-image-widths'));
      newImageElement.setAttribute('data-sizes', 'auto');

      if (window.theme && window.theme.productImageSize === 'natural') {
        originalImageElement.parentNode.style.paddingBottom =
          100.0 / target.getAttribute('data-image-aspect-ratio') + '%';
      }

      originalImageElement.parentNode.style.setProperty(
        '--aspect-ratio',
        target.getAttribute('data-image-aspect-ratio')
      );
      originalImageElement.parentNode.replaceChild(newImageElement, originalImageElement);

      if (window.lazySizes && window.lazySizes.loader) {
        window.lazySizes.loader.unveil(newImageElement);
      }
    });
  }

  function scrollCollectionIntoViewIfNeeded(collectionSection) {
    var collectionMain = collectionSection.querySelector('.CollectionMain');

    if (!collectionMain) {
      return;
    }

    var headerHeight = parseInt(document.documentElement.style.getPropertyValue('--header-height'), 10) || 0;
    var elementOffset = collectionMain.getBoundingClientRect().top - headerHeight;
    var toolbarElement = collectionSection.querySelector('.CollectionToolbar');

    if (
      window.theme &&
      window.Responsive &&
      window.Responsive.matchesBreakpoint('lap-and-up') &&
      toolbarElement &&
      toolbarElement.clientHeight === 0
    ) {
      elementOffset -= 50;
    }

    if (elementOffset < 0) {
      window.scrollBy({
        top: elementOffset,
        behavior: 'smooth'
      });
    }
  }

  function setLoadingState(isLoading, collectionProducts, subcategoriesSection) {
    if (collectionProducts) {
      collectionProducts.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      collectionProducts.classList.toggle('is-loading', isLoading);
    }

    if (subcategoriesSection) {
      subcategoriesSection.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      subcategoriesSection.classList.toggle('is-loading', isLoading);
    }
  }

  /**
   * Fetch another collection's main-collection section HTML and swap the product grid.
   * Does not change the browser URL or History API — nav stays on the original collection page.
   * The subcategory section is not re-fetched: its Liquid context belongs to the page collection.
   */
  function loadCollectionProducts(url) {
    var collectionSection = getCollectionSection();
    var subcategoriesSection = getCollectionSubcategoriesSection();
    var collectionProducts = getCollectionProductsContainer(collectionSection);

    if (!collectionSection || !collectionProducts) {
      return Promise.resolve(false);
    }

    var collectionSectionId = collectionSection.getAttribute('data-section-id');

    if (!collectionSectionId) {
      return Promise.resolve(false);
    }

    var requestId = ++activeRequestId;

    if (abortController) {
      abortController.abort();
    }

    abortController = new AbortController();
    setLoadingState(true, collectionProducts, subcategoriesSection);
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    var collectionFetchUrl = new URL(url, window.location.origin);
    collectionFetchUrl.searchParams.set('section_id', collectionSectionId);
    if (collectionSection.getAttribute('data-hide-multi') === 'true') {
      collectionFetchUrl.searchParams.set('view', 'no-multi');
    }

    return fetch(collectionFetchUrl.toString(), {
      credentials: 'same-origin',
      signal: abortController.signal
    })
      .then(function (response) {
        if (requestId !== activeRequestId) {
          return null;
        }

        if (!response.ok) {
          throw new Error('Collection subcategories request failed');
        }

        return response.text();
      })
      .then(function (collectionHtml) {
        if (requestId !== activeRequestId || collectionHtml == null) {
          return true;
        }

        var tempElement = document.createElement('div');
        tempElement.innerHTML = collectionHtml;

        applyCollectionContent(collectionSection, tempElement);
        if (collectionSection.getAttribute('data-hide-multi') === 'true') {
          document.dispatchEvent(new CustomEvent('collection:products-reloaded'));
        }
        setAjaxCollectionUrl(collectionSection, url);
        updateActiveSubcategory(subcategoriesSection, url);
        bindColorSwatchDelegation(collectionSection);
        revealProductItems(collectionSection);

        if (window.lazySizes && window.lazySizes.autoSizer) {
          window.lazySizes.autoSizer.checkElems();
        }

        scrollCollectionIntoViewIfNeeded(collectionSection);
        return true;
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') {
          return true;
        }

        return false;
      })
      .then(function (success) {
        if (requestId === activeRequestId) {
          setLoadingState(false, collectionProducts, subcategoriesSection);
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
        }

        return success;
      });
  }

  function isModifiedClick(event) {
    return (
      event.defaultPrevented ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      event.button !== 0
    );
  }

  function onClearClick(event) {
    var clearBtn = event.target && event.target.closest
      ? event.target.closest('[data-collection-subcats-clear]')
      : null;

    if (!clearBtn) {
      return;
    }

    var subcategoriesRoot = clearBtn.closest('[data-collection-subcategories]');

    if (
      !subcategoriesRoot ||
      !subcategoriesRoot.classList.contains('CollectionSubcats--featuredCards')
    ) {
      return;
    }

    // Same destination as Compact "All" / Shop All: the page's root collection.
    var rootUrl = subcategoriesRoot.getAttribute('data-root-collection-url');

    if (!rootUrl) {
      return;
    }

    if (
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      event.button !== 0
    ) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    if (!shouldEnhanceNavigation()) {
      window.location.assign(rootUrl);
      return;
    }

    loadCollectionProducts(rootUrl).then(function (success) {
      if (!success) {
        window.location.assign(rootUrl);
      }
    });
  }

  function onNavigationClick(event) {
    if (!shouldEnhanceNavigation()) {
      return;
    }

    // Featured clear control is handled separately (must not select the card).
    if (event.target && event.target.closest && event.target.closest('[data-collection-subcats-clear]')) {
      return;
    }

    var link = event.target.closest(NAV_SELECTOR);

    if (!link || isModifiedClick(event)) {
      return;
    }

    if (link.target && link.target !== '_self') {
      return;
    }

    var targetUrl = link.href;

    if (!targetUrl) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (link.classList.contains('is-active')) {
      return;
    }

    loadCollectionProducts(targetUrl).then(function (success) {
      if (!success) {
        window.location.assign(targetUrl);
      }
    });
  }

  document.addEventListener('click', onClearClick, true);
  document.addEventListener('click', onNavigationClick);
})();
